export type ExpirationLabelKey = "renewsOn" | "endsOn" | "manualExpires";

interface MinimalSub {
  paypalSubscriptionId: string;
  status?: string;
}

export function isManualSub(sub: { paypalSubscriptionId: string } | null | undefined): boolean {
  return !!sub && sub.paypalSubscriptionId.startsWith("MANUAL-");
}

export function expirationLabel(sub: MinimalSub): ExpirationLabelKey {
  if (sub.status === "cancelled") return "endsOn";
  if (isManualSub(sub)) return "manualExpires";
  return "renewsOn";
}
